var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11H7.33333C6.59695 11 6 11.597 6 12.3333V17C6 17.7364 6.59695 18.3333 7.33333 18.3333H16.6667C17.403 18.3333 18 17.7364 18 17V12.3333C18 11.597 17.403 11 16.6667 11Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 11V8.33333C8.6665 7.44928 9.01769 6.60143 9.64281 5.97631C10.2679 5.35119 11.1158 5 11.9998 5C12.8839 5 13.7317 5.35119 14.3569 5.97631C14.982 6.60143 15.3332 7.44928 15.3332 8.33333V11",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5e7e06a6a16d066349c14e1baad8fa15.svg";
export { ForwardRef as ReactComponent };